import { render, staticRenderFns } from "./ContratosBase.vue?vue&type=template&id=c55b0104&"
import script from "./ContratosBase.vue?vue&type=script&lang=ts&"
export * from "./ContratosBase.vue?vue&type=script&lang=ts&"
import style0 from "./ContratosBase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports